import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoaderService {
  private loading: boolean = true;

  isLoading = (): boolean => this.loading;

  setLoading = (): void => {
    setTimeout(() => this.loading = true);
  };

  setLoaded = (): void => {
    setTimeout(() => this.loading = false);
  };
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/loader.service.ts